import React from "react";

const KIND = {
  HISTORICAL: { label: "LMS", id: "lms", title: "Live LMS 1.0 database, read-only", cls: "bg-slate-100 text-slate-600 border-slate-300", dot: "bg-slate-400" },
  TEST_V3: { label: "HQ", id: "hq", title: "Captured in HQ; not yet in the LMS", cls: "bg-amber-50 text-amber-800 border-amber-400", dot: "bg-amber-500" },
  MOCK: { label: "Mock", id: "mock", title: "Simulated provider step — no live integration", cls: "bg-violet-50 text-violet-700 border-violet-300", dot: "bg-violet-500" },
  SNAPSHOT: { label: "Historical · 2025-06-30", id: "historical", title: "Frozen loanbooks monthly snapshot; not the current position", cls: "bg-slate-50 text-slate-500 border-slate-300", dot: "bg-slate-300" },
};

export const SourceBadge = ({ source, className = "" }) => {
  const k = KIND[source] || KIND.TEST_V3;
  return (
    <span title={k.title} data-testid={`source-badge-${k.id}`}
      className={`inline-flex items-center gap-1 border rounded px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-[0.08em] ${k.cls} ${className}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${k.dot}`} />
      {k.label}
    </span>
  );
};
